import React, { useMemo, useContext }from "react";
import * as Yup from "yup"; 
import { Formik } from "formik";
import { MutationResult } from '@apollo/client';
import { TextField, Typography ,Button, Box} from '@material-ui/core';
import { useHistory } from "react-router-dom";
import { useSignInMutation, SignInMutationVariables, SignInMutation } from "../../generated/graphql";
import { authContext } from "../auth/AuthContext";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Link } from "react-router-dom";
import { Space ,Spin, Modal } from "antd";

interface Props {}

const initialValues = {
    email: "",
    password: "",
}

const validationScheme = Yup.object().shape({
    email: Yup.string()
        .email("It should be an email")
        .required("This field is required"),
    password: Yup.string().required("This field is required")
});
const config = {
    title: 'Warning',
    content: (
        <> 
            <div>Email / Password combo are incorrect, please try again</div>
        </>
    ),
}

export const SignIn = (props: Props) => {
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

    const theme = useMemo(
      () =>
        createTheme({
          palette: {
            type: prefersDarkMode ? 'dark' : 'light',
          },
        }),
      [prefersDarkMode],
    );
  
    const [signin, { loading }] = useSignInMutation();
    const [modal, contextHolder] = Modal.useModal();
    const context = useContext(authContext);
    const history = useHistory();
    
    const userLoggedInHandler = (data: MutationResult<SignInMutation>['data']) => {
        if (data?.login) {
            localStorage.setItem("user_token", data.login.accessToken);
            localStorage.setItem("user_id", data.login.id);
            context?.setIsUserSignedIn(true);
            history.push(`/profile/${data.login.id}`);
        } else {
        }
    }

    const signinHandler = (values: SignInMutationVariables) => {
        signin({ variables: values })
            .then(({errors, data}) => {
                console.log('hit')
                if (errors) {
                    alert('Email / Password combo are incorrect, please try again')
                }
                return errors ? console.error(errors) : userLoggedInHandler(data)
             })
             .catch( () => {
                    // TODO: Create error modal 
                    modal.warning(config)
                }
             );
    };

    return( <ThemeProvider theme={theme}>
        <CssBaseline/>
        <Box width={300} margin="30px auto">
     
            <Typography style={{'color':'white'}} variant="h6">Sign In</Typography>
            <Formik
                initialValues={initialValues}
                validationScheme={validationScheme}
                onSubmit={signinHandler}
                >
                {({ values,
                    touched,
                    errors,
                    isValid,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isInitialValid}) => (<form onSubmit={handleSubmit}>
                        <TextField 
                            label="Email"
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            style={{'color':'white'}}
                            error={!!(errors.email && touched.email)}
                            helperText={
                                errors.email && touched.email && errors.email
                            }
                            margin="normal"
                        />
                         <TextField 
                            label="Password"
                            name="password"
                            value={values.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="password"
                            style={{'color':'white'}}
                            fullWidth
                            error={!!(errors.password && touched.password)}
                            helperText={
                                errors.password && touched.password && errors.password
                            }
                            margin="normal"
                        />
                        <br/>
                        <br/>
                        <Button
                            variant="contained"
                            fullWidth
                            type="submit"
                            color="primary"
                            disabled={!isValid || !!isInitialValid || loading}
                            >
                            Sign In
                        </Button>
                        { loading ? (<Space  style={{width:"100%", margin: '0 auto', maxWidth: '1000px'}} size={2} direction="vertical" align="center">
                            <Spin />
                        </Space>): ''}
                    </form>)}
                </Formik>   
                {contextHolder}
            <br/>
            <br/>
            <br/>
            <span style={{width:'100%', display:'flex', flexDirection:'column', alignItems:"center"}}>
                <Typography style={{'color':'white'}} variant="h6">Don't have an account yet? </Typography><br/>
                
                    <Link to='/signup'>
                        <Button variant="contained"
                                type="submit"
                                fullWidth
                                color="primary">
                            Sign up
                        </Button>
                    </Link> 
            </span>
            <br/>
        </Box>
    </ThemeProvider>
    )
}